import PlaceholderCard from "../../components/PlaceholderCard";
import { CardGrid, Section } from "../../components/Layout";
import { mixpanelLink, MIXPANEL_BOARD } from "../../mixpanel";

/**
 * The three permanent Mixpanel-only placeholders, together.
 *
 * All three are session/behavioural metrics with no Firestore equivalent —
 * Firestore records state, not visits, so there is no "this user opened the app
 * today" record to count — and no Mixpanel Query API service account will be
 * built, because Markit is on the free tier and its API access cuts off partway
 * through every month. A card that works for 27 days and then silently breaks is
 * worse than an honest placeholder, so these are a decision rather than a gap.
 * Do not later "fix" them by approximating them from Firestore: an activity
 * proxy built from document writes answers a different question while wearing
 * the name of this one.
 *
 * **The Standard user funnel joined them in Sep 2026**, from the deleted
 * Activation section. It was the one card there that was not Instagram, and it
 * belongs here on its own merits rather than as a leftover: it is the same kind
 * of unbuildable session funnel as the two beside it, and grouping the three
 * makes the permanence read as deliberate instead of looking like three
 * unfinished cards scattered across the page.
 *
 * The first two deep-link to the board rather than a report ID: they live on the
 * Other Important Metrics board as report-links with no stable bookmark ID to
 * address. Linking the board is honest; inventing a report ID would 404.
 */
const RetentionSection = () => (
  <Section
    title="Retention"
    description="Do creators come back? Every card here is a permanent placeholder — these are session metrics Firestore cannot answer, and Mixpanel's free tier cannot be queried reliably."
  >
    <CardGrid min={340}>
      <PlaceholderCard
        title="Advanced retention"
        source="Mixpanel · Other Important Metrics board (report ID unresolved — board link)"
        shape="line"
        link={mixpanelLink.board(MIXPANEL_BOARD.otherImportantMetrics)}
        linkLabel="Open board"
      />
      <PlaceholderCard
        title="Daily active users"
        source="Mixpanel · Other Important Metrics · DAUs (board link)"
        shape="line"
        link={mixpanelLink.board(MIXPANEL_BOARD.otherImportantMetrics)}
        linkLabel="Open board"
      />
      <PlaceholderCard
        title="Standard user funnel"
        source="Mixpanel · Retention · Standard User Funnel (funnels 49258155) — session-based, no Firestore equivalent"
        shape="funnel"
        height={200}
        link={mixpanelLink.funnels("49258155")}
        linkLabel="Open in Mixpanel"
      />
    </CardGrid>
  </Section>
);

export default RetentionSection;
